import type { ReactNode } from 'react'

import { APP_DISPLAY_NAME } from '@/lib/appDisplayName'

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex min-h-dvh flex-col bg-background text-foreground">
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -left-32 -top-24 h-[28rem] w-[28rem] rounded-full bg-primary/15 blur-3xl float-animation" />
        <div className="absolute -right-24 bottom-0 h-[22rem] w-[22rem] rounded-full bg-secondary/20 blur-3xl float-animation-delayed" />
      </div>
      <div className="relative flex flex-1 flex-col items-center justify-center px-4 py-12">{children}</div>
      <p className="relative pb-6 text-center text-xs text-muted-foreground">{APP_DISPLAY_NAME}</p>
    </div>
  )
}
